// src/components/PortfolioRegForm.js

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { addFormData, checkTalentUsernameExists, auth } from '../firebase';

export default function PortfolioRegForm({ closeModal = () => {} }) {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    bio: '',
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const { username } = form;

    // 1) Check username availability
    if (!username) {
      setError('Username is required');
      return;
    }
    if (await checkTalentUsernameExists(username)) {
      setError('Username already taken! Choose another.');
      return;
    }    

    // 2) Prepare payload with ownerUid
    const user = auth.currentUser;
    if (!user) {
      setError('You must be signed in to create a portfolio');
      return;
    }

    const payload = {
      ...form,
      ownerUid: user.uid,
      createdAt: new Date().toISOString()
    };

    // 3) Write to Firestore
    try {
      await addFormData(payload, 'NewPortfolios', username);
      // 4) Reset and navigate
      setForm({ name: '', email: '', phone: '', bio: '', username: '', password: '' });
      navigate(`/portfolio/${username}`);
    } catch (err) {
      console.error('Error launching portfolio:', err);
      setError('Failed to create portfolio. Please try again.');
    }
  };

  return (
    <form className="portfolio-reg-form" onSubmit={handleSubmit}>
      {error && <div style={{ color: 'red', marginBottom: '0.5rem' }}>{error}</div>}

      <input
        type="text"
        name="name"
        placeholder="Full Name"
        value={form.name}
        onChange={handleChange}
        required
      />

      <input
        type="email"
        name="email"
        placeholder="Email Address"
        value={form.email}
        onChange={handleChange}
        required
      />

      <input
        type="text"
        name="phone"
        placeholder="Contact Number"
        value={form.phone}
        onChange={handleChange}
      />

      <textarea
        name="bio"
        className="input-field about-field"
        placeholder="About You"
        value={form.bio}
        onChange={handleChange}
        rows="4"
        required
      />

      <input
        type="text"
        name="username"
        placeholder="Username"
        value={form.username}
        onChange={handleChange}
        required
      />

      <input
        type="password"
        name="password"
        placeholder="Access Code"
        value={form.password}
        onChange={handleChange}
        required
      />

      <button type="submit" className="button primary is-fullwidth">
        Launch Portfolio
      </button>
    </form>
  );
}
